import type { LiteralUnion } from 'type-fest'
import { cookieRef } from '@layouts/stores/config'

export const resolveVuetifyTheme = (defaultTheme: LiteralUnion<'light' | 'dark' | 'system', string>): 'light' | 'dark' => {
  const cookieColorScheme = cookieRef<'light' | 'dark'>('color-scheme', usePreferredDark().value ? 'dark' : 'light')
  const storedTheme = cookieRef('theme', defaultTheme).value

  const systemTheme: 'light' | 'dark' = cookieColorScheme.value === 'dark' ? 'dark' : 'light'

  return storedTheme === 'system'
    ? systemTheme
    : storedTheme as 'light' | 'dark'
}
